export enum CorrectionsPreviewRateQueryParamsUrlEnum {
  proNbr = 'proNbr',
  requestId = 'requestId',
  correctionRequestInstId = 'correctionRequestInstId',
  queueName = 'queueName',
  formView = 'formView',
  status = 'status',
  requestDateTime = 'requestDateTime'
};
